import { RouterChild } from '@/router';

export default [
  {
    name: 'profitabilities-list',
    path: 'conservator/profitabilities',
    component: () => import('./views/List.vue')
  } as RouterChild
];
